import React, { useEffect, useRef, useState } from "react";
import api from "../../services/api";

const brl = cents => (Number(cents || 0) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
const percentage = value => Number(value || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 4 });

export default function FluxopayFeePassThroughSimulation({ enabled, amount, paymentMethod, installments = 1, onChange }) {
  const [passFees, setPassFees] = useState(false);
  const [simulation, setSimulation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    const cents = Math.round(Number(amount || 0) * 100);
    if (!enabled || cents < 100) { setSimulation(null); onChangeRef.current?.(null); return undefined; }
    const timer = setTimeout(async () => {
      setLoading(true); setError("");
      try {
        const { data } = await api.post("/api/fluxopay/asaas/simulate-with-fee-pass-through", {
          service_amount_cents: cents, payment_method: paymentMethod,
          installments: paymentMethod === "credit_card" ? Number(installments || 1) : 1,
          pass_fees_to_customer: passFees,
        });
        setSimulation(data); onChangeRef.current?.(data);
      } catch (requestError) {
        setSimulation(null); onChangeRef.current?.(null);
        setError(requestError?.response?.data?.message || "Não foi possível calcular o repasse das taxas.");
      } finally { setLoading(false); }
    }, 450);
    return () => clearTimeout(timer);
  }, [enabled, amount, paymentMethod, installments, passFees]);

  if (!enabled) return null;
  return <div style={{ marginTop: 12, padding: 14, border: "1px solid #bfdbfe", borderRadius: 12, background: "#eff6ff" }}>
    <label style={{ display: "flex", alignItems: "flex-start", gap: 9, cursor: "pointer", color: "#1e3a8a", fontSize: 13, fontWeight: 700 }}>
      <input type="checkbox" checked={passFees} onChange={event => setPassFees(event.target.checked)} />
      Repassar as taxas do pagamento para o cliente
    </label>
    <small style={{ display: "block", color: "#475569", margin: "6px 0 10px 24px" }}>O paciente verá e pagará o acréscimo antes de abrir o checkout.</small>
    {loading && <small>Calculando condições...</small>}
    {error && <small style={{ color: "#b91c1c" }}>{error}</small>}
    {simulation && !loading && <>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 8 }}>
        <Metric label="Serviços da clínica" value={brl(simulation.service_amount_cents)} />
        <Metric label={`Asaas (${percentage(simulation.provider_fee_percentage)}% + ${brl(simulation.provider_operation_fee_cents)})`} value={`− ${brl(simulation.provider_fee_cents)}`} />
        <Metric label={`Fluxopay (${percentage(simulation.platform_fee_percentage)}%)`} value={`− ${brl(simulation.platform_fee_cents)}`} />
        {simulation.fees_passed_to_customer && <Metric label="Acréscimo ao cliente" value={`+ ${brl(simulation.customer_fee_cents)}`} />}
        <Metric label="Total cobrado" value={brl(simulation.gross_amount_cents)} strong />
        <Metric label="Líquido previsto da clínica" value={brl(simulation.clinic_net_cents)} strong />
      </div>
      <small style={{ display: "block", marginTop: 9, color: "#475569" }}>Estimativa. O valor definitivo será confirmado pela conciliação do Asaas.</small>
    </>}
  </div>;
}

function Metric({ label, value, strong }) {
  return <div style={{ padding: 9, background: "#fff", border: "1px solid #dbeafe", borderRadius: 9 }}><small style={{ display: "block", color: "#64748b" }}>{label}</small><b style={{ color: strong ? "#166534" : "#0f172a" }}>{value}</b></div>;
}
